"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var react_input_mask_1 = __importDefault(require("react-input-mask"));
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorPhoneView = function (props) {
    var appOrder = (0, CalculatorContextInterface_1.useCalculatorContext)().appOrder;
    var _a = (0, react_i18next_1.useTranslation)(), t = _a.t, i18n = _a.i18n;
    var _b = (0, react_hook_form_1.useFormContext)(), register = _b.register, errors = _b.formState.errors, control = _b.control, setValue = _b.setValue, watch = _b.watch;
    var _c = (0, react_1.useState)(), phone = _c[0], setPhone = _c[1];
    var inputRef = (0, react_1.useRef)(null);
    function handleCostKeyChange(e) {
        var regex = /[0-9]|\./;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    }
    (0, react_1.useEffect)(function () {
        //console.log("erors phone",errors.phone);
    }, [errors.phone]);
    (0, react_1.useEffect)(function () {
        if (appOrder && appOrder.user_phone) {
            setValue("phone", appOrder.user_phone);
            setPhone(appOrder.user_phone);
            if (inputRef.current) {
                inputRef.current.value = appOrder.user_phone;
            }
        }
    }, [appOrder]);
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("div", { className: "__wrap-top-item" }, errors.phone
            ?
                react_1.default.createElement("div", { className: "__has-error" }, t("calculator.phone.error.emty"))
            :
                react_1.default.createElement("span", { className: "__top-notification" }, t("calculator.phone.input.caption"))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)('__input-icon-wrap', errors.phone ? "__error" : "", (phone === null || phone === void 0 ? void 0 : phone.replace(/[^0-9]/g, '').length) == 12 ? "__succeess" : "") },
            react_1.default.createElement("span", { className: "icon" }, "+"),
            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: "phone", rules: {
                    required: true,
                    onChange: function (e) { setPhone(e.target.value); },
                    validate: {
                        length: function (v) {
                            return v.replace(/[^0-9]/g, '').length == 12;
                        }
                    },
                }, render: function (_a) {
                    var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value;
                    return (react_1.default.createElement(react_input_mask_1.default, { autoComplete: "off", ref: inputRef, mask: "999 (99) 999-99-99", 
                        //maskChar={null}
                        //onKeyPress={handleCostKeyChange}
                        className: "form-control", onChange: onChange, placeholder: t("calculator.phone.input.placeholder") }));
                } }))));
};
exports.default = CalculatorPhoneView;
